import { LocalStorageEnum } from "./enums";

export default class LS {
  static LStorage: Storage;
  static cartVersions: LocalStorageEnum[];
  static latestCartVersion: LocalStorageEnum;

  static defineLStorage() {
    const isBrowser = typeof window !== "undefined";

    if (!isBrowser) {
      return;
    }
    if (LS.LStorage === null || LS.LStorage === undefined) {
      try {
        LS.LStorage = window.localStorage;
      } catch (error) {
        console.log("error defining local storage", error);
        // Reading window.localStorage throws a SecurityError when storage is
        // blocked (blocked cookies, private mode, sandboxed iframe, in-app
        // webview). Leave LStorage undefined so reads/writes degrade to no-ops
        // instead of throwing before the caller's real work (e.g. sending an OTP).
      }
    }
    this.cartVersions = [
      LocalStorageEnum.CARTV1,
      LocalStorageEnum.CARTV2,
      LocalStorageEnum.CARTV3,
    ];
    this.latestCartVersion = this.cartVersions[this.cartVersions.length - 1];
  }

  static _get(key: LocalStorageEnum, parse: boolean = false) {
    LS.defineLStorage();
    try {
      let returned: any = LS.LStorage?.getItem(key);
      if (returned) {
        returned = parse === true ? JSON.parse(returned) : returned;
      }

      // Normalize undefined (storage unavailable) to null so callers that do
      // `JSON.parse(LS._get(...))` get `JSON.parse(null)` (=> null) instead of
      // `JSON.parse(undefined)` (=> SyntaxError).
      return returned ?? null;
    } catch (error) {
      // Storage inaccessible (SecurityError) or the stored value was
      // unparseable. Degrade to null rather than throwing.
      console.log("error getting local storage", error);

      return null;
    }
  }

  static _set(key: LocalStorageEnum, value: any, stringify: boolean = false) {
    LS.defineLStorage();
    try {
      if (stringify) {
        LS.LStorage?.setItem(key, JSON.stringify(value));
      } else {
        LS.LStorage?.setItem(key, value);
      }
    } catch (error) {
      // Storage inacces  sible (SecurityError) or over quota; ignore so the
      // caller doesn't throw.
      console.log("error setting local storage", error);
    }
  }

  static _delete(key: LocalStorageEnum) {
    LS.defineLStorage();
    try {
      LS.LStorage?.removeItem(key);
    } catch (error) {
      // Storage inaccessible; ignore.
      console.log("error deleting local storage", error);
    }
  }

  static _clearItems(keys: LocalStorageEnum[]) {
    LS.defineLStorage();
    try {
      if (keys.length > 0) {
        keys.forEach((key) => LS._delete(key));
      } else {
        LS.LStorage?.clear();
      }
    } catch (error) {
      // Storage inaccessible; ignore.
      console.log("error clearing local storage", error);
    }
  }

  static _checkLocalStorageIfBlocked() {
    try {
      window.localStorage;

      return false;
    } catch (error) {
      if (`${error}` === "SecurityError: The operation is insecure.") {
        console.log("can't access local storage", error);

        return true;
      }

      return false;
    }
  }
}
